import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import * as icons from 'apollo-react-icons';
import React from 'react';

import LazyText from '../../components/LazyText';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { isNilOrEmpty } from '../../utils/ramdaUtils';
import { parseStylesFromString } from '../../utils/styleUtils';
import { FORM_MODEL_ATTRIBUTES } from '../constants/form-manager.constants';
import {
  getClosestParentWithEntityName,
  getEvaluatedExpression,
} from '../selectors/form-manager.selectors';

const useStyles = makeStyles({
  root: {
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    marginRight: 8,
    display: 'flex',
  },
});

const SSStaticText = ({ id, index, text, displayIcon, displayIconColor, isEditor }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const Icon = displayIcon && icons[displayIcon];

  const iconProps = {
    htmlColor: colors[displayIconColor ?? 'neutral7'],
  };

  const entityName = useFormSelector(getClosestParentWithEntityName, { id });
  const selectorProps = { id, index, entityName };
  const evaluatedText = useFormSelector(getEvaluatedExpression, {
    ...selectorProps,
    prop: FORM_MODEL_ATTRIBUTES.TEXT,
    defaultValue: text,
  });
  const evaluatedStyles = useFormSelector(getEvaluatedExpression, {
    ...selectorProps,
    prop: FORM_MODEL_ATTRIBUTES.STYLE,
    defaultValue: '',
  });
  const translateData = useFormSelector(getEvaluatedExpression, {
    ...selectorProps,
    prop: FORM_MODEL_ATTRIBUTES.TRANSLATE_DATA,
  });

  const runtimeValue = translateData ? translateString(evaluatedText) : evaluatedText;
  const editorValue = isNilOrEmpty(runtimeValue) ? 'Static Text' : runtimeValue;
  const renderValue = isEditor ? editorValue : runtimeValue;

  return (
    <LazyText text={renderValue}>
      <span
        id={id}
        className={classes.root}
        style={evaluatedStyles ? parseStylesFromString(evaluatedStyles) : null}
        ui-ta={getUITA('FormCtrl', 'SSStaticText')}
      >
        {Icon && (
          <span className={classes.iconContainer}>
            <Icon {...iconProps} />
          </span>
        )}
        {renderValue}
      </span>
    </LazyText>
  );
};

export default SSStaticText;
